import React from "react";
import PropTypes from "prop-types";
import { CardNumberElement } from "@stripe/react-stripe-js";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  stripeElement: {
    borderColor: "#E8EAEF !important",
    borderStyle: "solid !important",
    borderWidth: 1,
    height: 48,
    fontSize: theme.typography.pxToRem(14),
    padding: "12px 8px",
    ".StripeElement--focus": {
      boxShadow: "0 1px 3px 0 #cfd7df",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
}));
const CARD_ELEMENT_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      color: "#0000008a",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#0000008a",
      },
      iconColor: "#4187B6",
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export default function CardNumber({ disabled }) {
  const classes = useStyles();
  return (
    <CardNumberElement
      options={{ ...CARD_ELEMENT_OPTIONS, disabled }}
      className={classes.stripeElement}
    />
  );
}

CardNumber.propTypes = {
  disabled: PropTypes.bool,
};

CardNumber.defaultProps = {
  disabled: false,
};
